import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const SlimHamburgerMenu = createSvgIcon(
  <svg viewBox="-10 -10 33 84">
    <path d="M12.8,38.4 L12.8,25.6 L0,25.6 L0,38.4 L12.32608,38.4 L12.8,38.4 Z M0,64 L12.8,64 L12.8,51.2 L0,51.2 L0,61.44 L0,64 Z M12.8,12.8 L12.8,0 L0,0 L0,12.8 L12.32608,12.8 L12.8,12.8 Z"></path>
  </svg>,
  'SlimHamburgerMenu'
);

export default SlimHamburgerMenu;
